
import './shopInfo.css'

const ShopInfo = ({ info = {} }) => { 

  return (
    <div className="shop-info">
      <div className="shop-info-item">
        <div className="top">
          昨日单数
        </div>
        <div className="top">
          {info.yesterday_order_num !== undefined ? info.yesterday_order_num : ""}
        </div>
      </div>
        <div className='line'></div>
      <div className="shop-info-item">
        <div className="top">
          昨日营业
        </div>
        <div className="top">
          {info.yesterday_turnover ? info.yesterday_turnover : ""}
        </div>
      </div>
        <div className='line'></div>
      <div className="shop-info-item">
        <div className="top">
          今日单数
        </div>
        <div className="top">
          {info.today_order_num!== undefined ? info.today_order_num : ""}
        </div>
      </div>
        <div className='line'></div>
      <div className="shop-info-item">
        <div className="top">
          今日营业
        </div>
        <div className="top">
          {info.today_turnover ? info.today_turnover : ""}
        </div>
      </div>
    </div>
  );
};


export default ShopInfo;
